<div id='actionCard'>
	<div class="background" style="background-color: {outerColor}">
		<h2 class="actionName {action.execution}">{action.name}</h2>
		<img src="../static/symbols/{action.domain}.bmp" class="domainsymbol" alt={action.domain} title="Domain {action.domain}" />
		<div class=inner style="background-color: {innerColor}">
			{#if action.TYPE === 'Power' || action.TYPE === 'Ability' || action.TYPE === 'Reaction'}
				<div class="powerHeader">
					<p title="bis zu {action.dist} F entfernt">{action.details.distance ?? 'Ziel'}</p>
					<p title={action.aiming.repr}>{action.details.aiming}</p>
					<p>Wenn</p>
					<p>Voraussetzungen</p>
					<p title="span={action.span}, repeat={action.multiple}">{action.details.span}</p>
					<p class=powerCoding title={codingText}>{action.codings}</p>
					{#if action.tiers}
						{#each action.tiers as tier, i}
							{#if view.layout.page === 'rules' || i < (view.persona?.powers?.[action.name] ?? 0)}
									<p>Grad {i+1}</p>
									<p>{tier}</p>
							{/if}
						{/each}
					{/if}
					{#if action.details.error}
							<p></p>
							<p><u>{action.details.error}</u></p>
					{/if}
				</div>
			{/if}
			<p class=descript>{@html action.descript?.replace(/\n/g, "<br />")}</p>
		</div>
		<div id="powerFooter" class="cardFooter">
			{#if action.TYPE === 'Power' || action.TYPE === 'Reaction' || action.TYPE === 'Ability'}
				<p class="powerExecution" title="Wurf auf Fertigkeit">{executionTxt[action.execution]}</p>
				<p class="powerExertion">{action.exertion ?? '0'} FP</p>
				<p class="powerTerm" title="Dauer der Aktion">{action.details.term}</p>
			{/if}
		</div>
	</div>
</div>

<script>
	import { user, game, view } from "../client.svelte.js";
	import {calc_activityColor, impactHue, executionTxt} from "../core.js";

	let { action } = $props()
	let outerColor = $derived(calc_activityColor(action))
	let innerColor = $derived(
		(action.execution === 'passive') ? "lightgrey" :
		(action.execution === 'reactive') ? `hsl(${(action.kind) ? impactHue[action.kind] : 210}, 50%, 75%)` :
		"white")
	let codingText = $derived((action.details?.effect) ? action.details.effect : (action.codingTxt !== "") ? action.codingTxt : "Mit Spielleiter zu klären!")

	// $inspect(`ACTIONCARD - action`, action)

</script>


<style lang="sass">
	#actionCard
		position: relative
		width: 400px
		//resize: both
		overflow: auto
		font-family: 'EB Garamond', serif
		color: black
		padding: 8px
		break-inside: avoid

	.background
		border-radius: 12px

	.close
		color: #aaaaaa
		float: right
		font-size: 28px
		font-weight: bold

	.close:hover
		color: #000
		text-decoration: none
		cursor: pointer

	.actionName
		margin: 0
		padding: 0.5em
		font-size: 150%

	.actionName.active
		font-style: normal
		text-decoration: none

	.actionName.proactive
		font-style: italic
		text-decoration: none

	.actionName.reactive
		font-style: normal
		text-decoration: underline

	.actionName.ultimative
		font-style: italic
		text-decoration: underline

	.domainsymbol
		position: absolute
		right: 8px
		top: 8px
		display: inline-block
		height: 4em
		width: 4em
		box-sizing: border-box
		box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2), 0 6px 20px 0 rgba(0,0,0,0.19)

	.inner
		margin: 0 1em
		padding: 4px

	.powerHeader
		display: grid
		grid-template-columns: 8ch auto
		padding: 8px
		font-weight: bolder

	.powerCoding
		white-space: pre-line

	.descript
		margin: 4px
		max-height: 40vh
		overflow-y: auto

	#abstractInput
		margin: 8px 15px 0 15px
		width: calc(100% - 30px)

	.cardFooter
		display: flex
		justify-content: space-between
		gap: 24px
		padding: 0.5em 0.5em
		font-size: 150%


	.powerExecution
		flex: 1
		text-align: left
		text-transform: capitalize
		font-weight: bold

	.powerExertion
		flex: 1
		text-align: center
		font-weight: bold

	.powerTerm
		flex: 1
		text-align: right
		font-weight: bold

	.powerTyped_progressiv
		background: linear-gradient(to top, white 0%, lightgray 100%) !important

</style>